import { format } from 'date-fns'



export function roundToNearest15(date) {
    let minutes = date.getMinutes();
    let addMinutes = 15 - (minutes % 15);
    if (addMinutes === 15) {
        addMinutes = 0;
    }
    date = new Date(date.getTime() + addMinutes * 60000); // Add the required minutes
    return date;
}

export function parseToFloat(str) {
    return parseFloat(str.replace(/,/g, ''));
}


export function groupByDateFormatAverage(data, dateFormat, formatsAvg) {
    const sortDaysOfWeek = (a, b) => {
        const order = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
        return order.indexOf(a.dateTime) - order.indexOf(b.dateTime);
    };

    const defaultSort = (a, b) => a.dateTime - b.dateTime;

    const sortFn = dateFormat === formatsAvg.weekly ? sortDaysOfWeek : defaultSort;

    const grouped = data.reduce((acc, curr) => {
        const dateTime = curr.dateTime;
        const formattedDateString = format(dateTime, dateFormat);

        if (!acc[formattedDateString]) {
            acc[formattedDateString] = { dateTime: formattedDateString, totalUsage: 0, count: 0 };
        }
        acc[formattedDateString].totalUsage += curr.usage;
        acc[formattedDateString].count += 1;
        return acc;
    }, {});

    const result = Object.values(grouped).map(({ dateTime, totalUsage, count }) => ({
        dateTime,
        usage: (totalUsage / count).toFixed(1)
    }));

    return result.sort(sortFn);
}


//costPerKwh is in cent
export function groupByDateFormatTotal(data, dateFormat, costPerKwh, sortFn = (a, b) => a - b) {
    const grouped = data.reduce((acc, curr) => {
        const dateTime = curr.dateTime;
        const formattedDateString = format(dateTime, dateFormat);

        if (!acc[formattedDateString]) {
            acc[formattedDateString] = { dateTime: formattedDateString, totalUsage: 0, totalCost: 0, totalCostSpot: 0 };
        }
        acc[formattedDateString].totalUsage += curr.usage;
        acc[formattedDateString].totalCost += costPerKwh / 100 * (curr.usage / 4);
        acc[formattedDateString].totalCostSpot += curr.spotPrice * (curr.usage / 4);


        return acc;
    }, {});



    const result = Object.values(grouped).map(({ dateTime, totalUsage, totalCost, totalCostSpot }) => ({
        dateTime,
        totalUsage: Math.round(totalUsage),
        totalCost: Math.round(totalCost),
        totalCostSpot: Math.round(totalCostSpot)
    }));

    return result.sort((a, b) => sortFn(a.dateTime, b.dateTime));
}

export function getTotals(data, costPerKwh) {
    const result = data.reduce((acc, curr) => {
        const totalUsage = acc.totalUsage + curr.usage;
        const totalCost = acc.totalCost + costPerKwh / 100 * (curr.usage / 4);
        const totalCostSpot = acc.totalCostSpot + curr.spotPrice * (curr.usage / 4);

        return { totalUsage, totalCost, totalCostSpot };
    }, { totalUsage: 0, totalCost: 0, totalCostSpot: 0 });

    result.totalUsage = Math.round(result.totalUsage);
    result.totalCost = Math.round(result.totalCost);
    result.totalCostSpot = Math.round(result.totalCostSpot);

    return result;
}


export function maxLoad(data) {
    if (!data || data.length === 0) {
        return { maxLoad: 0, dateTime: null };
    }

    const result = data.reduce((acc, curr) => {
        if (curr.usage > acc.maxLoad) {
            return { maxLoad: curr.usage, dateTime: curr.dateTime };
        }
        return acc;
    }, { maxLoad: 0, dateTime: null });

    return result;
}

export function totalUsage(data) {
    if (!data || data.length === 0) {
        return 0;
    }
    return (data.reduce((acc, curr) => acc + curr.usage, 0)) / 4
}


export function averageLoad(data) {
    if (!data || data.length === 0) {
        return 0;
    }
    return (data.reduce((acc, curr) => acc + curr.usage, 0)) / data.length;
}


export function averageLoadNighttime(data) {
    if (!data || data.length === 0) {
        return 0;
    }
    const nighttimeData = data.filter(item => {
        const hour = format(item.dateTime, "HH")
        const hourInt = parseInt(hour);
        return hourInt < 6;
    });

    if (nighttimeData.length === 0) {
        return 0;
    }

    return (nighttimeData.reduce((acc, curr) => acc + curr.usage, 0)) / nighttimeData.length;
}

export function groupByMonthAndMaxUsage(data) {
    const groupedData = {};

    data.forEach(item => {
        const monthYear = format(item.dateTime, "yyyy-MM");
        const monthYearFormatted = format(item.dateTime, "yyyy MMM");
        const day = format(item.dateTime, "yyyy-MM-dd");

        if (!groupedData[monthYear]) {
            groupedData[monthYear] = {
                name: monthYearFormatted,
                days: {}
            };
        }

        groupedData[monthYear].days[day] = Math.max(groupedData[monthYear].days[day] || 0, item.usage);
    });

    const result = Object.keys(groupedData)
        .sort((a, b) => Date.parse(b) - Date.parse(a))
        .map(monthYear => {
            const days = Object.keys(groupedData[monthYear].days);
            const maxUsages = days.map(day => groupedData[monthYear].days[day]);

            return {
                name: groupedData[monthYear].name,
                data: maxUsages
            };
        });
    return result;
}

export function calculatePercentiles(data) {
    const usageValues = data.map(item => item.usage).sort((a, b) => a - b);

    function getPercentile(p) {
        const position = (p / 100) * (usageValues.length - 1) + 1;
        const base = Math.floor(position) - 1;
        const remainder = position - base - 1;

        if (base + 1 < usageValues.length) {
            return usageValues[base] + remainder * (usageValues[base + 1] - usageValues[base]);
        }
        return usageValues[base];
    }

    const percentiles = {};
    for (let i = 1; i < 100; i++) {
        percentiles[i] = getPercentile(i);
    }

    return percentiles;
}